module.exports = __webpack_public_path__ + "img/Driver_motor.a8b063ed.png";